import React, { useState } from "react";
import { sbFetch } from "../utils/supabaseClient";
import { useToast } from "./Toast";
import "../styles/CreateTab.css";

const NewsEditModal = ({ news, onSave, onCancel }) => {
  const { success, error } = useToast();
  const [url, setUrl] = useState(news.url || "");
  const [title, setTitle] = useState(news.title || "");
  const [imageUrl, setImageUrl] = useState(news.image_url || "");
  const [scheduledDate, setScheduledDate] = useState(news.scheduled_date ? new Date(news.scheduled_date).toISOString().slice(0, 10) : "");
  const [whatItMeans, setWhatItMeans] = useState(news.what_does_it_mean_to_me || "");
  const [draft, setDraft] = useState(news.draft || false);
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!url.trim() || !title.trim()) {
      error("URL and Title are required");
      return;
    }

    try {
      new URL(url);
    } catch {
      error("Please enter a valid URL");
      return;
    }

    setSaving(true);
    try {
      const updated = {
        url: url.trim(),
        title: title.trim(),
        image_url: imageUrl.trim(),
        what_does_it_mean_to_me: whatItMeans.trim(),
        draft: draft,
      };

      if (scheduledDate) {
        updated.scheduled_date = new Date(scheduledDate).toISOString();
      }

      await sbFetch("PATCH", `news?id=eq.${news.id}`, updated);
      success("News item updated");
      onSave(updated);
    } catch (err) {
      console.error("Error updating news:", err);
      error("Failed to update news item");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onCancel}
    >
      <div
        style={{
          background: "#050e1a",
          borderRadius: "8px",
          width: "90%",
          maxWidth: "700px",
          maxHeight: "90vh",
          overflowY: "auto",
          border: "1px solid rgba(59, 130, 246, 0.2)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px", borderBottom: "1px solid rgba(59, 130, 246, 0.2)" }}>
          <h2 style={{ margin: 0, color: "#5B9EF0" }}>Edit News Item</h2>
          <button
            onClick={onCancel}
            style={{
              background: "transparent",
              border: "none",
              color: "#7A9CC4",
              fontSize: "24px",
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} style={{ padding: "20px" }}>
          <div className="form-group">
            <label>Article URL *</label>
            <input
              type="url"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="https://example.com/article"
              disabled={saving}
            />
          </div>

          {imageUrl && (
            <div className="form-group">
              <label>Preview Image</label>
              <img
                src={imageUrl}
                alt="Article preview"
                style={{
                  width: "100%",
                  maxHeight: "200px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  border: "1px solid rgba(59, 130, 246, 0.15)"
                }}
              />
            </div>
          )}

          <div className="form-group">
            <label>Image URL</label>
            <input
              type="url"
              value={imageUrl}
              onChange={(e) => setImageUrl(e.target.value)}
              placeholder="https://example.com/image.jpg"
              disabled={saving}
            />
          </div>

          <div className="form-group">
            <label>Title *</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="News headline"
              disabled={saving}
            />
          </div>

          <div className="form-group">
            <label>Scheduled Date (Optional)</label>
            <input
              type="date"
              value={scheduledDate}
              onChange={(e) => setScheduledDate(e.target.value)}
              disabled={saving}
              title="Schedule when this news item should be published"
              style={{ width: "100%" }}
            />
            <small style={{ color: "#7A9CC4", marginTop: "4px", display: "block" }}>
              Optional: Schedule this news item to be published on a future date
            </small>
          </div>

          <div className="form-group">
            <label>What It Means To You (Interpretation)</label>
            <textarea
              value={whatItMeans}
              onChange={(e) => setWhatItMeans(e.target.value)}
              placeholder="What does this news mean for leaders navigating AI adoption?"
              disabled={saving}
              style={{ minHeight: "100px" }}
            />
          </div>

          <div className="form-group">
            <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={!draft}
                onChange={(e) => setDraft(!e.target.checked)}
              />
              Published (unpublished news stays in draft and doesn't notify users)
            </label>
          </div>

          <div className="form-actions">
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? "Saving..." : "Save Changes"}
            </button>
            <button
              type="button"
              onClick={onCancel}
              className="btn-secondary"
              disabled={saving}
              style={{ background: "#6b7280" }}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewsEditModal;
